<app-header></app-header>
<app-page-title></app-page-title>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">

        <app-report-card-view></app-report-card-view>

      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>